// Issue #3202, Phase 4 (§7.6): clickable table rows as PROGRESSIVE ENHANCEMENT.
//
// The <tr> carries data-row-click-url-value (its show route) and marks the ONE
// real primary <a> as the "primary" target. A click anywhere on the row that is
// NOT already an interactive element navigates by delegating to the primary
// link's real .click() (honoring its turbo-frame / target / modifier behavior),
// falling back to Turbo.visit(urlValue). Rows work without JS: the primary <a>
// is a real link.

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }
  static targets = ["primary"]

  navigate(event) {
    // Ignore clicks that land on an already-interactive element (or an opted-out
    // cell) so links, buttons, checkboxes, selects and labels keep working.
    if (event.target.closest("a, button, input, select, label, [data-row-click-exempt]")) return

    if (this.hasPrimaryTarget) {
      this.primaryTarget.click()
    } else if (this.hasUrlValue && this.urlValue) {
      Turbo.visit(this.urlValue)
    }
  }
}
